import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';
import { IconButton, Tooltip } from '@mui/material';

import { useT } from '../i18n/LanguageContext';
import { useThemeMode } from '../theme/ThemeModeContext';

export const ThemeModeToggle = () => {
  const { mode, toggle } = useThemeMode();
  const t = useT();

  return (
    <Tooltip title={mode === 'dark' ? t('theme.toLight') : t('theme.toDark')}>
      <IconButton size="small" onClick={toggle} aria-label={t('theme.toggle')}>
        {mode === 'dark' ? (
          <LightModeOutlinedIcon fontSize="small" />
        ) : (
          <DarkModeOutlinedIcon fontSize="small" />
        )}
      </IconButton>
    </Tooltip>
  );
};
